export default __webpack_public_path__ + "static/media/your_role_m.c213ac88.jpg";